var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{on:{"click":function($event){return _vm.showSubjectModal()}}},[_vm._v("\n  Subject History\n  "),_c('i',{staticClass:"fas fa-notes-medical"})])}
var staticRenderFns = []

export { render, staticRenderFns }